<script lang="ts">
  export let fill = '#2A6295';
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.31137 0.946445C0.979422 1.27839 0.979422 1.81658 1.31137 2.14853L4.24982 5.08698L1.14054 8.19627C0.80859 8.52821 0.80859 9.0664 1.14054 9.39835C1.47248 9.73029 2.01067 9.73029 2.34262 9.39835L5.88321 5.85776C5.91068 5.83029 5.93587 5.80141 5.9588 5.77134C5.99204 5.74667 6.02389 5.71926 6.05404 5.68911C6.38598 5.35717 6.38598 4.81898 6.05404 4.48703L2.51345 0.946445C2.1815 0.614499 1.64331 0.614499 1.31137 0.946445Z"
    {fill}
  />
</svg>
